module.exports = "<div *ngIf=\"modalType == 'delete'\" >\n  <p>\n    Silmek sitediğinize emin misiniz?\n  </p>\n\n  <button mat-raised-button color=\"warn\" style=\"float: right\" (click)=\"delete()\">Sil</button>\n</div>\n\n<div *ngIf=\"modalType == 'detail'\">\n  <p>\n    {{data.key.message}}\n  </p>\n\n  <button mat-raised-button color=\"warn\" style=\"float: right\" (click)=\"close()\">Kapat</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/contact-infos/dialog/dialog.component.html
// module id = ../../../../../src/app/main/content/contact-infos/dialog/dialog.component.html
// module chunks = main